import axios, { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000/api';

console.log('API_BASE_URL:', API_BASE_URL); // Debug log

// Toast configuration
const TOAST_CONFIG = {
  position: 'top-right' as const,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

// Create axios instance with default configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// URL patterns that should not trigger a global success toast
const SILENT_SUCCESS_URLS = ['/media/upload', '/media/upload-multiple'];

// Response interceptor to handle common errors and show toasts
api.interceptors.response.use(
  (response) => {
    // Show success toast for successful responses (excluding GET requests to avoid spam)
    // Also exclude media upload endpoints which handle their own feedback
    const isSilent = SILENT_SUCCESS_URLS.some((u) => response.config.url?.includes(u));
    if (response.config.method !== 'get' && !isSilent) {
      const message = response.data?.message || 'Operation completed successfully';
      toast.success(message, {
        ...TOAST_CONFIG,
        autoClose: 3000,
      });
    }
    return response;
  },
  (error) => {
    // Handle 401 unauthorized - redirect without showing toast for better UX
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
      return Promise.reject(error);
    }

    // Extract error message
    const errorMessage = error.response?.data?.message || 
                        error.response?.data?.error || 
                        error.message || 
                        'An error occurred';
    
    // Show error toast
    toast.error(errorMessage, {
      ...TOAST_CONFIG,
      autoClose: 5000,
    });
    
    return Promise.reject(error);
  }
);

export default api;
